import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { urls } from 'assets/url/urls';
import { LoginService } from '../login/login.service';
import { Observable } from 'rxjs';
import { Employee } from 'app/model/employee';
import { DashboardEmployeeItem } from 'app/model/dashboardEmployee';

@Injectable({
  providedIn: 'root'
})
export class EmployeeService {
  private readonly REST_API_SERVER = `${urls.baseUrl}/employees`
  private readonly HEADERS = new HttpHeaders({
    'X-TENANT-ID': urls.tenant,
    'Authorization': 'Bearer ' + this.loginService.getToken()
  })

  /**
   * Constructor
   *
   * @param {HttpClient} http
   * @param {LoginService} loginService
   * 
  */
  constructor(
    private http: HttpClient,
    private loginService: LoginService
  ) { }

  public getAllEmployeeItems(): Observable<DashboardEmployeeItem[]> {
    const headers = this.HEADERS

    return this.http.get<DashboardEmployeeItem[]>(`${this.REST_API_SERVER}/dashboard`, { headers })
  }

  public getAllEmployeeItemsByDptId(dptId: number): Observable<DashboardEmployeeItem[]> {
    const headers = this.HEADERS

    return this.http.get<DashboardEmployeeItem[]>(`${this.REST_API_SERVER}/dashboard/department/${dptId}`, { headers })
  }

  public getCvByEmployeeId(employeeId: number): Observable<Blob> {
    const headers = this.HEADERS

    return this.http.get(`${this.REST_API_SERVER}/${employeeId}/cv`, {
      headers,
      responseType: 'blob'
    })
  }

  public updateCvByEmployeeId(employeeId: number, cv?: File): Observable<Blob> {
    const headers = this.HEADERS

    const formData = new FormData()

    if (cv) formData.append('cv', cv)

    return this.http.put(`${this.REST_API_SERVER}/${employeeId}/cv`, formData, {
      headers,
      responseType: 'blob'
    })
  }
}
